import BaseForm from "@common-components/form/components/BaseForm";
import RootStore from "@stores/RootStore";

export default class LoginForm extends BaseForm {
    constructor(hooks: any, fields: any, rootStore: RootStore) {
        super(hooks, fields, rootStore)
    }

    setup() {
        return {
            fields: [
                {
                    name: 'userName',
                    label: 'Email adresa',
                    placeholder: 'Unesi e-mail adresu ili korisničko ime',
                    rules: 'required|string',
                },
                {
                    name: 'password',
                    label: 'Lozinka',
                    placeholder: 'Unesi lozinku',
                    rules: 'required|string',
                    type: "password"
                }
            ],
        };
    }
}